import jwt from "jwt-decode";
import moment from "jalali-moment";

//* Start Number Utils
export const numberSeparate = (number) => {
  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};
//* End Number Utils

//* Start JWT Utils
export const decodeJWT = (token) => {
  if (!token) return;
  return jwt(token);
};
//* End JWT Utils

//* Start Date Utils
export const formatToPersianDate = (
  date,
  format = "YYYY-MM-DD",
  locale = "fa"
) => {
  if (!date || date === "0001-01-01T00:00:00") return "-";
  return moment(date).locale(locale).format(format);
};
//* End Date Utils

//* Start Clock Utils
export const formatToPersianClock = (
  date,
  format = "HH:mm:ss",
  locale = "fa"
) => {
  if (!date || date === "0001-01-01T00:00:00") return "-";
  return moment(date).locale(locale).format(format);
};
//* End Clock Utils

//* Start Default Picture
export const base64Image = (image) => `data:image/jpeg;base64,${image}`;
export const defaultPicture = base64Image(
  "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"
);
//* End Default Picture

// *
// Profile Random
// https://xsgames.co/randomusers/avatar.php?g=male
// *

//* Start Count Down Utils
export const secondsCountDown = (elementId, countdownTime, callBack) => {
  let countdown = setInterval(() => {
    let element = document.getElementById(elementId);

    countdownTime--;

    if (element) element.innerHTML = countdownTime;
    else clearInterval(countdown);

    if (countdownTime <= 0) {
      clearInterval(countdown);
      if (callBack) {
        callBack();
      }
    }
  }, 1000);
};
//* End Count Down Utils

//* Start Gender Type Utils
export const genderType = (type) => {
  switch (type) {
    case 0:
      return "نامشخص";

    case 1:
      return "مرد";

    case 2:
      return "زن";


    default:
      return "نامشخص";
  }
};
//* End Gender Type Utils

//* Start User Type Utils
export const userType = (type) => {
  switch (type) {
    case "C":
      return "کاربر";

    case "A":
      return "ادمین";

    default:
      return "نامشخص";
  }
};
//* End User Type Utils


//* Start Handle Convert Persian Number To English Number
export const convertPersianToEnglish = (str) => {
  const persianDigits = "۰۱۲۳۴۵۶۷۸۹".split("");
  const englishDigits = "0123456789".split("");

  return str.replace(
    /[۰-۹]/g,
    (char) => englishDigits[persianDigits.indexOf(char)] || char
  );

};
//* End Handle Convert Persian Number To English Number